import type { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import { DashboardLayout } from './layouts/DashboardLayout';
import { AdminLayout } from './layouts/AdminLayout';
import { HomePage } from './pages/HomePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { OffersPage } from './pages/OffersPage';
import { MarketplacePage } from './pages/MarketplacePage';
import { ContentPage } from './pages/ContentPage';
import { LinksPage } from './pages/LinksPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { TeamPage } from './pages/TeamPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { MerchantOnboardingPage } from './pages/MerchantOnboardingPage';
import { PublishingPage } from './pages/publishing';
import { BillingPage, SettingsPage } from './pages/settings';
import { AdminOverviewPage, AdminTenantsPage, AdminUsersPage, SlaMonitoringPage } from './pages/admin';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminRoute } from './components/AdminRoute';
import { ErrorBoundary } from './components/ErrorBoundary';

export function App(): ReactNode {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<ErrorBoundary><HomePage /></ErrorBoundary>} />
        <Route path="/marketplace" element={<ErrorBoundary><MarketplacePage /></ErrorBoundary>} />
        <Route path="/offers" element={<ErrorBoundary><OffersPage /></ErrorBoundary>} />
        <Route path="/content" element={<ErrorBoundary><ContentPage /></ErrorBoundary>} />
        <Route path="/links" element={<ErrorBoundary><LinksPage /></ErrorBoundary>} />
        <Route path="/analytics" element={<ErrorBoundary><AnalyticsPage /></ErrorBoundary>} />
        <Route path="/publishing" element={<ErrorBoundary><PublishingPage /></ErrorBoundary>} />
        <Route path="/team" element={<ErrorBoundary><TeamPage /></ErrorBoundary>} />
        <Route path="/integrations" element={<ErrorBoundary><IntegrationsPage /></ErrorBoundary>} />
        <Route path="/marketplace/merchant" element={<ErrorBoundary><MerchantOnboardingPage /></ErrorBoundary>} />
        <Route path="/settings" element={<ErrorBoundary><SettingsPage /></ErrorBoundary>} />
        <Route path="/settings/billing" element={<ErrorBoundary><BillingPage /></ErrorBoundary>} />
      </Route>

      {/* Admin routes */}
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route index element={<ErrorBoundary><AdminOverviewPage /></ErrorBoundary>} />
        <Route path="tenants" element={<ErrorBoundary><AdminTenantsPage /></ErrorBoundary>} />
        <Route path="users" element={<ErrorBoundary><AdminUsersPage /></ErrorBoundary>} />
        <Route path="sla" element={<ErrorBoundary><SlaMonitoringPage /></ErrorBoundary>} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
